<div class="c-property-edit__error" *ngIf="errorTypes.length">
  <ax-icon class="icon" name="alert-circle"></ax-icon>
  <span>{{
    errorTypes[0]
      | errorTranslationKey: propertyType
      | translate: {propertyType: ('property.' + propertyType + '.label' | translate)}
  }}</span>
</div>
